const Style = () => ({
  flex__field: {
    display: 'flex',
    flexDirection: 'column',
    width: '48% ',
  },

  fields__main: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '20px',
    color: '#6D7D8B',
    padding: '1.5rem 0 .65rem',
  },
  data__field: {
    background: 'transparent',
    border: '1px solid #AEB6B7',
    borderRadius: '100px',
    height: '42px',
    marginRight: '.7rem',
    width: '100%',
    '& .MuiInputBase-root': {
      height: '100%',
      padding: '0 1rem',
      '& input': {
        height: '100%',
        fontSize: '13px',
        fontWeight: '500',
        color: '#000',
        padding: '0',
      },
    },
  },
  is__error__border: {
    borderColor: '#FF3636 !important',
  },
});
export default Style;
